export default "__VITE_ASSET__BteeiIw1__"